import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const WrapperStyled = styled(Box)({
  width: '100%',
  backgroundColor: '#fff',
  border: `1px solid ${grey[300]}`,
  padding: '16px',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const CircleStyled = styled(Box)({
  width: 8,
  height: 8,
  borderRadius: '50%',
});
